import React, {useState, useEffect, useRef} from 'react';
import { injectIntl } from 'react-intl';
import { base64ToBytes, getFileSize, i18nIntl, imgPath, isEmpty } from '../../lib/ep.js';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import ActionButton from '../builder/ActionButton';
import BuilderCanvas from '../builder/BuilderCanvas';
import BuilderSidebar from '../builder/BuilderSidebar';

import Input from '../builder/Input';
import Model from '../builder/Model';
import { NavigationTabsBuilder } from '../builder/NavigationTabs';

import Layout from '../front/Layout';

import ColorPicker from '../builder/ColorPicker.js';
import ImageUploader, { AutoImageUploader } from '../builder/ImageUploader.js';
import DisabledArea from '../builder/DisabledArea.js';
import DynamicFields from '../builder/DynamicFields.js';
import CrushClient from '../front/CrushClient.js';
import Message from '../builder/Message.js';
import Select from '../builder/Select.js';
import Spinner from '../builder/Spinner';
import Range from '../builder/Range.js';
import { GameContainerWrapper } from '../front/GameContainer.js';
import BuilderMain from '../builder/BuilderMain.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import Checkbox from '../builder/Checkbox.js';
import GameInstructionsBuilder from './GameInstructionsBuilder.js';
import GameScoreBuilder from './GameScoreBuilder.js';
import GameSoundtrackFields from '../builder/GameSoundtrackFields.js';

let crush_min = [{k:'',v:'Choose the min crushes to win'}];
for(var i=5; i<=50 ; i=i+1) {
	crush_min.push({k:i,v:i});
}

const CrushField = ({ model, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [uploading, setUploading] = useState(false);

	const scores = [
		{ k:10, v:`10 ${i18n("points")}` },
		{ k:20, v:`20 ${i18n("points")}`},
		{ k:50, v:`50 ${i18n("points")}`},
	];

	const auto_img_hooks = (hook) => {
		switch(hook.type) {
			case 'AUTO_IMAGE_START':
				setUploading(true);
				break;

			case 'AUTO_IMAGE_END':
				setUploading(false);
				break;
		}
	}

	if(isEmpty(model, 'points')) {
		model.points = 10;
	}

	return (
		<DisabledArea disabled={uploading}>
			<Model model={model} change={change} errors={props.errors != undefined && props?.errors[model.id]}>
				<AutoImageUploader
					auto_url={`/promotions/auto_img/${props.promotion_id}`}
					auto_type='stages'
					changeMulti={props.changeMulti}
					hooks={auto_img_hooks}
					image={model.full_image}
					name="image"
					small_input={true}
					_size={{width:100, height:100}}
				>Image</AutoImageUploader>
				<Input name="name" _class={{size:70}} autotranslate={false}>{i18n("***Name").replace("***","")}</Input>
				<Select name="points" _class={{size:70}} values={scores} autotranslate={false}>{i18n("points", 'ucfirst')}</Select>
			</Model>
		</DisabledArea>
	)
};

const GameSettings = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [uploading, setUploading] = useState(false);
	const uploadingImages = useRef(0);
	const total_elements = (stage.crush_level != undefined) ? parseInt(stage.crush_level) : 5;

	useEffect(() => {
		if(stage.crush_images == undefined)validate([]);
	}, []);

	const uploadBulkImages = (k,v,name) => {
		if(name==undefined)return;
		const total_images = stage.crush_images != undefined ? (stage.crush_images).length : 0;
		if((total_images + uploadingImages.current + 1) > total_elements)return;//No upload more images than permitted
		uploadingImages.current++;
		setUploading(true);

		const file_size = getFileSize(base64ToBytes(v),0).replace(' ','');
		$.post(`/promotions/auto_img/${stage.promotion_id}/uploadSize_${file_size}`, { image:v, type:'stages', name:name }, (response) => {
			let new_image = {};
			new_image.id = uuidv4();
			new_image.title = "Image";
			new_image.type = 'crush_field';
			new_image.image = response.name;
			new_image.name = name!=undefined ? name.replace(/\\/g,'/').replace(/.*\//, '').replace(/\.[^/.]+$/, "").replace(/_/g, ' ').replace(/-/g, ' ') : 'Image';
			new_image.points = 10;
			new_image.full_image = imgPath(EP.BUCKET,stage.promotion_id,'stages') + new_image.image;

			let v = stage.crush_images != undefined ? [...stage.crush_images,new_image] : [new_image];
			validate(v);//Fa el change
			uploadingImages.current--;
			if(uploadingImages.current<=0)setUploading(false);
		}, 'json');

	}

	const validate = (v) => {
		v = (v == undefined) ? stage.crush_images : v;
		let errors = {};
		let total_images = v.length; //stage.crush_images != undefined ? Object.keys(stage.crush_images).length : 0;
		let errors_images = false;

		v.map((img) => {
			if(errors[img.id] == undefined) errors[img.id] = {};
			if(img.name == undefined || img.name == '') {
				errors[img.id]['name'] = i18n("Mandatory field");
				errors_images = true;
			}

			/*if(!img.points){
				errors[img.id]['points'] = i18n("Mandatory field");
				errors_images = true;
			}*/

			if(img.image == undefined || img.image == '') {
				errors[img.id]['image'] = i18n("Mandatory field");
				errors_images = true;
			}

			if(Object.keys(errors[img.id]).length == 0) delete errors[img.id];
		});

		/*const num_elements = stage.crush_level != undefined ? parseInt(stage.crush_level) : total_elements;
		if(total_images < num_elements) {
			const remaining_images = num_elements - total_images;

			if(remaining_images > 1) {
				errors['crush_images'] = props.intl.formatMessage({ id:"Still missing {remain} items" }, { remain:remaining_images });
			} else {
				errors['crush_images'] = i18n("Still missing 1 item");
			}
		}*/

		if(errors_images) errors['images'] = i18n("Some items are missing information");

		setErrors(errors);
		change('crush_images', v);

		setLoading(true);

		setTimeout(() => {
			setLoading(false);
		}, 0);
	}

	const changeSidebar = (k,v) => {
		change(k,v);
		validate();
	}

	const section_title = `${i18n("Items", 'ucfirst')} (${((stage.crush_images != undefined) ? stage.crush_images.length : 0)}/${total_elements})`;

	const dynamic_fields = [{
		type:'crush_field',
		label:false,
		title:(f) => (((f.name) ? `${f.name}` : "") + ((f.points) ? ` (${f.points} ${i18n("points")})` : "") + ((errors[f.id] != undefined) ? ` (${i18n("has errors")})` : "")),
	}];

	const option_level = [
		{ k:5, v:i18n("Easy") },
		{ k:6, v:i18n("Medium") },
		{ k:7, v:i18n("***Hard") },
	];
	const crush_images_for_play = (stage.crush_images != undefined) ? (stage.crush_images).slice(0, total_elements) : [];

	return (
		<>
			<BuilderSidebar onSave={props.saveStage} errors={errors}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<Message
					_class={{ other:'in_top' }}
				>
					<strong>{i18n("How does it work?")}</strong>

					<p>{i18n("Users swap two items to make a row or column of at least three matching items. Each swap counts as one move. The goal for the users is to achieve X moves before the time runs out.")}</p>

					<strong>{i18n("points", 'ucfirst')}</strong>

					<p>{i18n("Each match sums points. You can define the number of points per item. Combos multiply the number of points.")}</p>

					<strong>{i18n("Levels")}</strong>

					<p>{i18n("We have created three levels with default values to help you with the difficulty level but they can be changed. Adjust them to customize your game.")}</p>
				</Message>
				
				<article>
					<Model model={stage} change={changeSidebar}>
						<Select
							name="crush_level"
							value={total_elements}
							values={option_level}
							_class={{size:40, first:true}}
						>Level</Select>

						<Select
							name="crush_min"
							value={stage.crush_min}
							values={crush_min}
							_class={{size:40}}
						>Moves to achieve</Select>

						<Range
							min={30}
							max={300}
							step={5}
							label_props={{
								addition:"In seconds",
							}}
							name="game_time"
							value={(stage.game_time != undefined) ? Math.max(stage.game_time, 30) : 180}
						>Time limit to achieve the moves</Range>

						<Checkbox
							name='silence'
						>Disable sounds</Checkbox>
					</Model>

					<GameSoundtrackFields
						stage={stage}
						change={change}
					/>
				</article>

				<article class="gui_not_in_top gui_not_in_bottom">
					{(crush_images_for_play.length > 0) && (
						<DynamicFields
							section_title={section_title}
							max_items={5}
							onChange={validate}
							field_types={dynamic_fields}
							add_button_props={{
								icon:'knk-add-item mainButton',
							}}
							sortable={false}
							fields={crush_images_for_play}
						>
							<CrushField
								promotion_id={stage.promotion_id}
								errors={errors}
								intl={props.intl}
							/>
						</DynamicFields>
					)}

					<div class="gui_pos_rel gui_not_in_top">
						<DisabledArea disabled={crush_images_for_play.length >= total_elements} message="All items have already been uploaded">
							{(uploading) ? (
								<div class="gui_not_in_top gui_flex_center" style={{width:'100%',height:100}}>
									<Spinner>Uploading images</Spinner>
								</div>
							) : (
								<ImageUploader
									name="game_images"
									image={stage.full_roulette_custom_bg}
									change={uploadBulkImages}
									small_input={true}
									_size={{width:100, height:100}}
									display_custom_dragging_instructions="Select files"
									recommendations={`[${i18n("You can drag and drop multiple images to upload in batch. The items will take the name of the filename.")}]`}
								>Upload the image of a new item</ImageUploader>
							)}
						</DisabledArea>
					</div>

					<Model model={stage} change={change}>
						<ColorPicker
							_class={{size:60}}
							_hide_code={true}
							name="crush_bg_color"
							color={stage.crush_bg_color}
						>Background color</ColorPicker>

						<Checkbox
							name="display_outter_border"
							value={stage?.display_outter_border ?? true}
						>Display outer border</Checkbox>
					</Model>
				</article>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout promo={props.promotion} is_builder={true} page="quiz" menus={props.promoModel.Custom__Menus} layout_extra_classes="is_new_game">
					<div style={{width:'100%'}}>
						{(loading) ? (
							<div class="gui_not_in_top gui_flex_center" style={{width:'100%',height:'100%'}}>
								<Spinner>Generating a new board</Spinner>
							</div>
						) : (
							(Object.keys(errors).length == 0) ? (
								<CrushClient stage={{Stage:stage}} is_builder={true} is_playable={true} section="settings" />
							) : (
								<GameContainerWrapper>
									<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
										{Object.values(errors).map((error, i) => {
											let is_object = (typeof error === 'object') ? true : false;
											if(is_object) return null;
											return (
												<p key={`error${i}`}>{error}</p>
											)
										})}
									</div>
								</GameContainerWrapper>
							)
						)}
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const GameTest = ({ stage, change, ...props }) => {
	const restart = () => {
		let new_reset = stage.reset != undefined ? stage.reset + 1 : 0;
		change('reset',new_reset);
	};

	return (
		<>
			<BuilderSidebar without_ctas={true}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<ButtonCollection>
					<ActionButton
						icon='knk-reload'
						onClick={() => restart()}
					>Restart game</ActionButton>
				</ButtonCollection>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout promo={props.promotion} is_builder={true} page="quiz" menus={props.promoModel.Custom__Menus} layout_extra_classes="is_new_game">
					<div style={{width:'100%'}}>
						<CrushClient stage={{Stage:stage}} is_builder={true} is_test={true} />
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const CrushBuilder = ({ base_route, stage, ...props }) => {
	const basename = `/stages/${stage.id}/crush`;
	const nav_sections = [
		{ label:"Go back", link:`/stages/${stage.id}/options`, icon:'knk-go-prev' },
		{ label:"Gameplay settings", link:`${basename}/settings`, icon:'knk-settings' },
		{ label:"Instructions", link:`${basename}/instructions`, icon:'knk-help' },
		{ label:"Score screen", link:`${basename}/gamescore`, icon:'knk-like' },
		{ label:"Test the game", link:`${basename}/test`, icon:'knk-ok' },
	];

	const common_props = {
		stage,
		is_multistage:props.is_multistage,
		isCorporate:props.isCorporate,
		change:props.change,
		changeMulti:props.changeMulti,
		intl:props.intl,
		promotion:props.promotion,
		promoModel:props.promoModel,
		saveStage:props.saveStage,
		stage_indicator:props.stage_indicator,
		nav_sections:nav_sections,
	};

	return (
		<BuilderMain pm={props.promoModel}>
			<Router basename={basename} hashType="noslash">
				<Switch>
					<Route exact={true} path="/settings">
						<GameSettings
							{...common_props}
							nav_active={`/settings`}
						/>
					</Route>

					<Route exact={true} path="/instructions">
						<GameInstructionsBuilder
							{...common_props}
							nav_active={`/instructions`}
						>
							<CrushClient
								stage={{ Stage:stage }}
								promotion={props.promotion}
								is_builder={true}
								section="instructions"
							/>
						</GameInstructionsBuilder>
					</Route>

					<Route exact={true} path="/gamescore">
						<GameScoreBuilder
							{...common_props}
							nav_active={`/gamescore`}
							exclude_cases={['fail', 'out_of_moves']}
						>
							<CrushClient
								stage={{ Stage:stage }}
								promotion={props.promotion}
								is_builder={true}
								section="score"
							/>
						</GameScoreBuilder>
					</Route>

					<Route exact={true} path="/test">
						<GameTest
							{...common_props}
							nav_active={`/test`}
						/>
					</Route>
				</Switch>
			</Router>
		</BuilderMain>
	)
}
export default injectIntl(CrushBuilder);